import { render } from "./terms-page.vue?vue&type=template&id=310ac197&ts=true"
import script from "./terms-page.vue?vue&type=script&lang=ts"
export * from "./terms-page.vue?vue&type=script&lang=ts"

import "./terms-page.vue?vue&type=style&index=0&id=310ac197&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__